import { MarkdownContent } from '../MarkdownContent';

interface Props {
  props: { content?: string };
}

export function PanelMarkdown({ props }: Props) {
  return <MarkdownContent content={props?.content ?? ''} />;
}
